import { jsx as n } from "react/jsx-runtime";
import { Hint as m } from "@systemeio/ui";
import { useEditorState as u } from "../node_modules/@tiptap/react/dist/index.mjs";
import { twMerge as s } from "tailwind-merge";
function p({
  hint: c,
  editor: o,
  className: a
}) {
  const r = u({
    editor: o,
    selector: ({ editor: t }) => ({
      count: t == null ? void 0 : t.storage.characterCount.characters()
    })
  });
  if (!o) return null;
  const e = (r == null ? void 0 : r.count) || "";
  return e ? /* @__PURE__ */ n(m, { label: c ?? "", showHint: !!c, className: s(a, "h-5"), children: /* @__PURE__ */ n("span", { className: "mt-[2px]", children: e }) }) : /* @__PURE__ */ n("div", { className: s(a, "h-5") });
}
export {
  p as CharacterCount
};
